export enum Status {
  Initial,
  Checking,
  Complete,
  Invalid,
}
